import ItemCarousel from "../components/ItemCarousel";
import '../assets/styles/Trade.css'
import React, { useEffect, useState } from "react";
import ItemCard from "../components/ItemCard";
import Button from "react-bootstrap/esm/Button";
import Alert from 'react-bootstrap/Alert';
import "../assets/styles/Spinner.css";
import Dota2Logo from '../assets/images/dota2bw.png';
import CS2Logo from '../assets/images/cs2bw.png';
import ItemInfoCanva from "../components/ItemInfoCanva";

import Form from 'react-bootstrap/Form';
import ItemFilterCanva from "../components/ItemFilterCanva";
import ItemInfoModal from "../components/ItemInfoModal";

export default function Trade(props) {
    const [offeringItems, setOfferingItems] = useState([])
    const [offeringItemsValue, setOfferingItemsValue] = useState(0)

    const [askingItems, setAskingItems] = useState([])
    const [askingItemsValue, setAskingItemsValue] = useState(0)

    const [userAvailableItems, setUserAvailableItems] = useState([])
    const [botAvailableItems, setBotAvailableItems] = useState([])

    const [priceDifferenceVisible, setPriceDifferenceVisible] = useState(false)

    const [userFilteredItems, setUserFilteredItems] = useState([]);
    const [botFilteredItems, setBotFilteredItems] = useState([])

    const [offerSentAlertVisible, setOfferSentAlertVisible] = useState(false)
    const [sentOfferId, setSentOfferId] = useState("")

    const [spinnerVisible, setSpinnerVisible] = useState(false)
    const [tradeBtnVisible, setTradeBtnVisible] = useState(false)

    const [userSearchText, setUserSearchText] = useState("")
    const [itemFilterCanvaVisible, setItemFilterCanvaVisible] = useState(false)

    const [botSearchText, setBotSearchText] = useState("")

    // const [itemInfoCanvaVisible, setItemInfoCanvaVisible] = useState(false);
    // const [canvaItemInfo, setCanvaItemInfo] = useState({})

    const [itemInfoModalVisible, setItemInfoModalVisible] = useState(false)
    const [itemInfoModalData, setItemInfoModalData] = useState({})

    // Loads User & Bot Inventory
    useEffect(() => {

        fetch('/api/inventory/user/dota2')
            .then(res => {
                if (!res.ok) {
                    console.log('Error fetching user inventory')
                } else {
                    return res.json()
                }
            })
            .then(userItems => {
                const userItemsMap = userItems
                    .filter(p => (p.tradable === true) && (p.marketable === true))
                    .map((p) => ({
                        assetId: p.assetid,
                        priceSafe: p.pricesafe,
                        image: p.image,
                        name: p.marketname,
                        rarityColor: p.tags.find(tag => tag.category === "Rarity")?.color || "ffffff",
                        rarityName: p.tags.find(tag => tag.category === "Rarity")?.localized_tag_name || "Unknown Rarity",
                        heroName: p.tags.find(tag => tag.category === "Hero")?.localized_tag_name || null,
                        slot: p.tags.find(tag => tag.category === "Slot")?.localized_tag_name || null,
                        type: p.tags.find(tag => tag.category === "Type")?.localized_tag_name || null,
                        steamUrl: p.steamurl,
                        descriptions: p.descriptions
                    }));
                setUserAvailableItems(userItemsMap);
            })
            .catch(error => {
                console.log(error)
            })


        fetch('/api/inventory/bot/dota2')
            .then(res => {
                if (!res.ok) {
                    console.log('Error fetching bot inventory')
                } else {
                    return res.json()
                }
            })
            .then(botItems => {
                const botItemsMap = botItems.filter(p => (p.pricesafe !== null))
                // const botItemsMap = botItems.filter(p => (p.tradable === true) && (p.marketable === true) && (p.pricesafe !== null))
                    .map((p) => ({
                        assetId: p.assetid,
                        priceSafe: p.pricesafe,
                        image: p.image,
                        name: p.marketname,
                        rarityColor: p.tags.find(tag => tag.category === "Rarity")?.color || "ffffff",
                        rarityName: p.tags.find(tag => tag.category === "Rarity")?.localized_tag_name || "Unknown Rarity",
                        heroName: p.tags.find(tag => tag.category === "Hero")?.localized_tag_name || null,
                        slot: p.tags.find(tag => tag.category === "Slot")?.localized_tag_name || null,
                        type: p.tags.find(tag => tag.category === "Type")?.localized_tag_name || null,
                        steamUrl: p.steamurl,
                        descriptions: p.descriptions
                    }));

                setBotAvailableItems(botItemsMap)
            })
            .catch(error => {
                console.log(error)
            })
    }, []);


    // Calculates offered & asked items total value
    useEffect(() => {
        let total = askingItems.reduce((total, item) => total + item.priceSafe, 0);
        setAskingItemsValue(parseFloat(total.toFixed(2)))
    }, [askingItems]);

    useEffect(() => {
        let total = offeringItems.reduce((total, item) => total + item.priceSafe, 0);
        setOfferingItemsValue(parseFloat(total.toFixed(2)))
    }, [offeringItems]);

    // Handles user and bot item search
    useEffect(() => {
        if (userSearchText.length === 0)
            setUserFilteredItems(userAvailableItems)
        else
            setUserFilteredItems(userAvailableItems.filter(item => item.name.toLowerCase().includes(userSearchText.toLowerCase())))
    }, [userSearchText, userAvailableItems])

    useEffect(() => {
        if (botSearchText.length === 0)
            setBotFilteredItems(botAvailableItems)
        else
            setBotFilteredItems(botAvailableItems.filter(item => item.name.toLowerCase().includes(botSearchText.toLowerCase())))
    }, [botSearchText, botAvailableItems])

    // Fair trade values check
    useEffect(() => {
        if ((offeringItemsValue >= askingItemsValue) && (offeringItemsValue > 0)) {
            setTradeBtnVisible(true)
            setPriceDifferenceVisible(false)
        } else {
            setTradeBtnVisible(false)
            if (askingItemsValue > 0)
                setPriceDifferenceVisible(true)
            else
                setPriceDifferenceVisible(false)
        }

    }, [offeringItemsValue, askingItemsValue])

    // Send id's of items participating in trade. Backend then creates the according trade offer to the user
    const confirmTrade = () => {
        setTradeBtnVisible(false)
        setSpinnerVisible(true)

        fetch('api/sendOffer', {
            method: "POST",
            credentials: "include",
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify({
                askingItems: askingItems,
                offeringItems: offeringItems
            })
        })
            .then(res => {
                if (!res.ok) {
                    console.log('Error creating offer')
                } else {
                    return res.json()
                }
            })
            .then(data => {
                setSpinnerVisible(false)
                setSentOfferId(data.offerId)
                setOfferSentAlertVisible(true)
            })
            .catch(error => {
                console.log(error)
            })
    }

    // Select item for trade logic
    const handleItemOffering = (assetId) => {
        let targetItem = userAvailableItems.find(item => item.assetId === assetId);
        let newAvailableItems = userAvailableItems.filter(item => item.assetId !== assetId);
        setUserAvailableItems(newAvailableItems);
        if (targetItem) {
            setOfferingItems([...offeringItems, targetItem]);
        }
    };

    const handleItemAsking = (assetId) => {
        let targetItem = botAvailableItems.find(item => item.assetId === assetId);
        let newAvailableItems = botAvailableItems.filter(item => item.assetId !== assetId);
        setBotAvailableItems(newAvailableItems);
        if (targetItem) {
            setAskingItems([...askingItems, targetItem]);
        }
    };

    // Html
    return (
        <div className="trade">
            <Alert closeVariant={'white'} className='fw-bold alert-fixed-top text-center' style={{fontSize: '1.2em', backgroundColor: '#032830', color: '#6edff6'}} show={offerSentAlertVisible} defaultShow={false} onClick={() => setOfferSentAlertVisible(false)} key={'offerSentAlert'} variant={'info'} dismissible>
                Offer #{sentOfferId} has been sent ✅
                Thank you for choosing SkinFlip 💙
            </Alert>
            <ItemFilterCanva
                key={2}
                placement={'end'}
                itemfiltercanvavisible={itemFilterCanvaVisible}
                setitemfiltercanvavisible={setItemFilterCanvaVisible}
            />
            <ItemInfoModal
                id='item-info-modal'
                key={1}
                show={itemInfoModalVisible}
                onHide={() => setItemInfoModalVisible(false)}
                keyboard={true}
                backdrop={false}
                enforceFocus={false}
                iteminfomodaldata={itemInfoModalData}
            />
            {/* <ItemInfoCanva 
                steamid={props.steamid} 
                key={1} 
                placement={'end'} 
                name={'end'} 
                canvaItemInfo={canvaItemInfo} 
                setItemInfoCanvaVisible={setItemInfoCanvaVisible} 
                itemInfoCanvaVisible={itemInfoCanvaVisible} 
            /> */}
            {/* Trade Button */}
            <div className="w-100 d-flex align-items-center flex-column justify-content-center mt-3">
                {priceDifferenceVisible ? <span id="price-difference" className="fs-2 fw-bold text-light"> Add {parseFloat((askingItemsValue - offeringItemsValue).toFixed(2))} $ in value to complete the trade ...</span> : ""}
                {tradeBtnVisible ? <Button tabIndex={-1} onClick={confirmTrade} className="tradeBtn btn-transparent fw-bold text-light border border-light border-3 mt-3">Confirm Trade</Button> : " "}
                {spinnerVisible ?
                    <div className="fw-bold d-flex flex-column align-items-center justify-content-center w-100">
                        <span id="trade-spinner" className="trade-spinner"></span>
                        <span className="fw-bold text-light loading-message">A trade offer is being sent...</span>
                    </div> : ""}
            </div>
            {/* Carousels */}
            <div style={{ position: 'relative' }} className="w-100 d-flex justify-content-center align-items-center mt-5 ">
                <div style={{ position: 'absolute', top: '50%', zIndex: 999 }} className="fs-1 rounded-circle border border-light border-3 pe-2 ps-2 bg-dark">
                    <i className="bi bi-arrow-left-right text-light"></i>
                </div>
                <div className="ms-5 item-carousel-container">
                    <div className="rounded ms-auto mb-2 itemValue fw-bold text-light d-flex align-items-center justify-content-center fw-bold">{offeringItemsValue} $</div>
                    <ItemCarousel itemOwner='user' title="Offering Items" setItemInfoModalData={setItemInfoModalData} setItemInfoModalVisible={setItemInfoModalVisible} userAvailableItems={userAvailableItems} offeringItems={offeringItems} setUserAvailableItems={setUserAvailableItems} setOfferingItems={setOfferingItems} />
                </div>
                <div className="ms-3 me-5 item-carousel-container">
                    <div className="rounded me-auto mb-2 itemValue fw-bold text-light d-flex align-items-center justify-content-center fw-bold">{askingItemsValue} $</div>
                    <ItemCarousel itemOwner='bot' title="Ask Items" setItemInfoModalData={setItemInfoModalData} setItemInfoModalVisible={setItemInfoModalVisible} botAvailableItems={botAvailableItems} askingItems={askingItems} setBotAvailableItems={setBotAvailableItems} setAskingItems={setAskingItems} />
                </div>
            </div>
            {/* Search */}
            <div className="w-100 align-items-center justify-content-center mt-3 d-flex">
                <div className="ms-5 d-flex align-items-center item-search-form item-grid-bar rounded">
                    {/* <Button variant="dark" onClick={() => setItemFilterCanvaVisible(true)} className="border border-2 border-light me-auto">
                        <div className="text-light fw-bold item-filter-btn d-flex align-items-center">
                            <i className="me-2 border-0 bi bi-filter-square"></i>
                            Filter
                        </div>
                    </Button> */}
                    <Form.Control
                        type="text"
                        className="text-light fw-bold ms-2"
                        id="user-item-search"
                        placeholder="Search for items..."
                        onChange={(e) => setUserSearchText(e.target.value)}
                    />
                </div>
                <div className="ms-3 me-5 d-flex align-items-center item-search-form item-grid-bar rounded">
                    {/* <Button variant="dark" onClick={() => setItemFilterCanvaVisible(true)} className="border border-2 border-light me-auto">
                        <div className="text-light fw-bold item-filter-btn d-flex align-items-center">
                            <i className="me-2 border-0 bi bi-filter-square"></i>
                            Filter
                        </div>  
                    </Button> */}
                    <Form.Control
                        type="text"
                        className="text-light fw-bold ms-2"
                        id="bot-item-search"
                        placeholder="Search for items..."
                        onChange={(e) => setBotSearchText(e.target.value)}
                    />
                </div>
            </div>
            {/* Item Grids */}
            <div className="w-100 d-flex align-items-center justify-content-center mt-2 mb-5">
                <div id="userInventory" className="inventory-container d-flex flex-column ms-5">
                    {/* <div className="gameSelector bg-dark d-flex justify-content-center align-items-center">
                        <div className="gameOption me-2" style={{ backgroundImage: `url(${Dota2Logo})` }}>

                        </div>
                        <div className="gameOption" style={{ backgroundImage: `url(${CS2Logo})` }}>

                        </div>
                    </div> */}
                    {props.isAuthenticated ?
                        <div className="itemGrid">
                            {userFilteredItems.map((item) => (
                                <ItemCard
                                    key={item.assetId}
                                    setItemInfoModalData={setItemInfoModalData}
                                    setItemInfoModalVisible={setItemInfoModalVisible}
                                    itemData={item}
                                    onClick={() => handleItemOffering(item.assetId)}
                                />
                            ))}
                        </div>
                        :
                        <div style={{ flexFlow: 'unset', overflow: 'hidden' }} className="itemGrid justify-content-center align-items-center">
                            <a href="/api/auth/steam" className="border rounded border-3 text-light login-with-steam">Login with Steam <i className="ms-3 bi bi-steam"></i></a>
                        </div>
                    }

                </div>

                <div id="botInventory" className="inventory-container d-flex flex-column ms-3 me-5">
                    {/* <div className="gameSelector align-self-end bg-dark d-flex justify-content-center align-items-center">
                        <div className="gameOption me-2" style={{ backgroundImage: `url(${Dota2Logo})` }}>

                        </div>
                        <div className="gameOption border border-light border-2" style={{ backgroundImage: `url(${CS2Logo})` }}>

                        </div>
                    </div> */}
                    <div className="itemGrid">
                        {botFilteredItems.map((item) => (
                            <ItemCard
                                key={item.assetId}
                                setItemInfoModalData={setItemInfoModalData}
                                setItemInfoModalVisible={setItemInfoModalVisible}
                                itemData={item}
                                onClick={() => handleItemAsking(item.assetId)}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}